import Axios from "../../../networking/interceptor";

import { createAsyncThunk } from "@reduxjs/toolkit";
import { driver_update_delivery_status } from "../../../networking/urlEndPoints";

import { fetchTodayMissed } from "./todayMissed";
import { removeTodayDispenePatientById } from "../../slices/dispense/patientForRouteList";
import { removePatientById } from "../../slices/dispense/patientPendingList";
import { removeFlexiDeliverById } from "../../slices/dispense/flexiDeliver";
import { fetchPatientPendingList } from "./patientPendingList";
import { extractNestedApiErrorMessage } from "../../../utils/helper/apiErrorMessage";

export const updateDeliveryStatus = createAsyncThunk('updateDeliveryStatus', async (requesteData, { rejectWithValue }) => {

	const { pharmacy_id,
		frequency_dose_id,
		missed_explanation,
		patient_id,
		type,
		tab,
		dispatch,
		setOpenIndex,
		setMissedDeliveryConfirmation,
		setMissedDeliveryErrorToast,
		setMissedExplanation,
		missedPatientListIndex,
		delivery_latitude,
		delivery_longitude,
		// flexi_rx_refill_id,
		deliver_rx_ids,
		has_selected_deliver_rx_ids } = requesteData

	try {

		const payloadData = {
			pharmacy_id: pharmacy_id,
		}

		if (delivery_latitude !== null && delivery_latitude !== undefined) {
			payloadData.delivery_latitude = delivery_latitude;
		}

		if (delivery_longitude !== null && delivery_longitude !== undefined) {
			payloadData.delivery_longitude = delivery_longitude;
		}

		if (frequency_dose_id?.length > 0) {
			payloadData.frequency_dose_id = frequency_dose_id;
		}

		if (has_selected_deliver_rx_ids === true) {
			payloadData.winrx_data_id = deliver_rx_ids || [];
			payloadData.has_selected_deliver_rx_ids = true;
		} else if (deliver_rx_ids?.length > 0) {
			payloadData.winrx_data_id = deliver_rx_ids;
		}

		if (missed_explanation) {
			payloadData.missed_explanation = missed_explanation;
		}

		// if (flexi_rx_refill_id?.length > 0) {
		// 	payloadData.flexi_rx_refill_id = flexi_rx_refill_id;
		// }

		const response = await Axios.post(`${driver_update_delivery_status}/${patient_id}`, payloadData);
		const data = response.data;

		const nestedBusinessMsg = extractNestedApiErrorMessage(data);
		if (data?.success === false) {
			if (typeof setOpenIndex === 'function') {
				setOpenIndex(null);
			}
			if (typeof setMissedDeliveryConfirmation === 'function') {
				setMissedDeliveryConfirmation(false);
			}
			if (nestedBusinessMsg) {
				if (typeof setMissedDeliveryErrorToast === 'function') {
					setMissedDeliveryErrorToast(true);
					setTimeout(() => setMissedDeliveryErrorToast(false), 8000);
				}
				return rejectWithValue({ userFacingMessage: nestedBusinessMsg });
			}
			if (typeof setMissedDeliveryErrorToast === 'function') {
				setMissedDeliveryErrorToast(true);
				setTimeout(() => setMissedDeliveryErrorToast(false), 3000);
			}
			return rejectWithValue({ userFacingMessage: null });
		}

		if (response?.status === 200) {
			if (type === 'today_missed') {
				if (pharmacy_id) {
					const params = {
						pharmacy_id: requesteData.pharmacy_id,
						status: 'today_missed',
						...(tab ? { tab } : {}),
					};
					dispatch(fetchTodayMissed(params))
				}
			} else if (type === 'today_dispense' && requesteData.params?.pharmacy_id && requesteData.params?.route) {
				dispatch(removeTodayDispenePatientById(patient_id))
				dispatch(fetchTodayMissed(requesteData.params))
			} else if (type === 'flexi_deliver') {
				dispatch(removeFlexiDeliverById(patient_id))
			} else if (type === 'pending_dispense') {
				dispatch(removePatientById(patient_id))
			}

			if (typeof setMissedExplanation === 'function') {
				setMissedExplanation('');
			}
			if (typeof missedPatientListIndex === 'number') {
				const idx = missedPatientListIndex;
				setTimeout(() => {
					const nextPatientCard = document.getElementById(`patientCard-${idx + 1}`);
					if (nextPatientCard) {
						nextPatientCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
					}
				}, 100);
			}
		}

		if (typeof setOpenIndex === 'function') {
			setOpenIndex(null)
		}

		if (typeof setMissedDeliveryConfirmation === "function") {
			setMissedDeliveryConfirmation(false)
		}

		return data;

	} catch (error) {
		const resData = error?.response?.data;
		const nestedMsg = extractNestedApiErrorMessage(resData);

		if (typeof setMissedDeliveryConfirmation === "function") {
			setMissedDeliveryConfirmation(false);
		}

		if (nestedMsg) {
			if (typeof setMissedDeliveryErrorToast === "function") {
				setMissedDeliveryErrorToast(true);
				setTimeout(() => setMissedDeliveryErrorToast(false), 8000);
			}
			if (type === 'Pending_dispense') {
				dispatch(fetchPatientPendingList({
					page: 1,
					pharmacy_id: pharmacy_id,
				}));
			}
			return rejectWithValue({ userFacingMessage: nestedMsg });
		}

		const topLevelMsg = typeof resData?.message === 'string' && resData.message.trim() ? resData.message.trim() : '';
		if (topLevelMsg) {
			window.alert(topLevelMsg);
		}

		if (typeof setMissedDeliveryErrorToast === "function") {
			setMissedDeliveryErrorToast(true);
			setTimeout(() => setMissedDeliveryErrorToast(false), 3000);
		}

		if (type === 'Pending_dispense') {
			dispatch(fetchPatientPendingList({
				page: 1,
				pharmacy_id: pharmacy_id,
			}));
		}
		return rejectWithValue({ userFacingMessage: null, inner: error.response });
	}
});
